/**
 * @Author: Zero
 * @Date: 2026-06-09 14:43:34
 * @Explain: 邀请用户邮件接受邀请验证页面（未登录可直接访问）
 */
export default {
  'INVITED.MATURITY_TIME': 'This invation from was expire in',
  'INVITED.ASK_FOR_INVITED': 'You can ask for the invitation for one more time',
  'INVITED.HAVE_ACCEPTED': 'You have accepted the invitation',
  'INVITED.JOIN_THE_PROJECT': 'Join the project',
  'INVITED.RETURN_TO_LOGIN': 'Return to Login',
};
